/**
 * 新增 编辑
 * @author 3173
 * @date 2020-7-20
 */
import React, {Component} from 'react';
import {Form} from 'antd'
import {component_tool, framework_tool} from '@/tool'
import {WizTableForm} from '../../../common'
import ScoreEditList from './inputScore/scoreEditList'

let {WizAvatarUpload, ossFileUtils} = framework_tool
const abilityCheckItem = WizTableForm.Config.abilityCheckItem(this, {apiParams: { state: 1,categoryState:1   }})

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class StudentAbilityItemForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      positionIds: [],
      orgId: [],
      abilityCheckItemId: null
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
      this.clearWizCallBack = [];
  }

  /** 获取能力项 */
  getNextNeedData(abilityCheckItemId, abilityCheckCategoryId) {
    if (this.props.getNextNeedData) {
      this.props.getNextNeedData(abilityCheckItemId, abilityCheckCategoryId)
    }
  }

  /** 获取能力项 */
  getNextNeedPersonIdListData(abilityCheckItemId) {
    if (this.props.getNextNeedPersonIdListData) {
      this.props.getNextNeedPersonIdListData(abilityCheckItemId)
    }
  }


  /** 获取数据存到state中，调用相应接口获取数据 */
  getTrainAbilityCheckItem(values, e) {
    let row = values.valueRows;
    if (row && row[0]) {
      let data = row[0]
      let positionIdString = data.positionIds ? data.positionIds : '';
      let positionIds = []
      if (positionIdString) {
        positionIds = positionIdString.split(",");
      }
      this.setState({
        positionNames: data.positionNames,
        orgName: data.orgName,
        orgId: [data.orgId],
        trainAbilityCheckItemName: data.name,
        abilityCheckItemId: data.id,
        positionIds: positionIds,
        abilityCheckCategoryId: data.abilityCheckCategoryId,
        //清除学员信息
        userPositionNames: undefined,
        userPositionIds: undefined,
        personId: undefined,
        userName: undefined
      })
      if (this.props.form && this.props.form.setFieldsValue) {
        this.props.form.setFieldsValue({personId: null})
      }
      if (this.cleanStudent) {
        this.cleanStudent()
      }
      this.getNextNeedData(data.id, data.abilityCheckCategoryId)
      this.getNextNeedPersonIdListData(data.id)
    }
  }

  /** 获取学员信息 */
  getPersonInfo(values, e) {
    let row = values.valueRows;
    if (row && row[0]) {
      let data = row[0]
      this.setState({
        userPositionNames: data.positionNames,
        userPositionIds: data.positionIds,
        personId: data.personId,
        userName: data.userName
      })
    }

  }

  setData(list) {
    if (list) {
      list.forEach(data => {
        let positionNames="";
        let positionIds = [];
        data.orgName = this.state.orgName
        if(data.identityInfos){
          data.identityInfos.forEach(identityInfo=>{
            positionNames+=identityInfo.positionName+",";
            positionIds.push(identityInfo.positionId);
          })
        }
        if(positionNames){
          positionNames= positionNames.substring(0,positionNames.length-1)
          data["positionNames"]=positionNames;
          data.positionIds = positionIds;
        }
      })
    }
   
    // list.push(positionList);
  }

  /**清除学员信息 */
  clearOnChange(nextTargetValues) {
    let other = {}
    if(!nextTargetValues){
      other.abilityCheckItemId = undefined;
      other.positionNames = undefined;
    }
    this.setState({
      userPositionNames: undefined,
      userPositionIds: undefined,
      personId: undefined,
      userName: undefined,
      ...other
    })
    if (this.cleanStudent) {
      this.cleanStudent()
    }
  }

  studentColumns() {
    const positionConfig = WizTableForm.Config.position(this, {
      apiParams: {
        state: 1,
        positionIds: this.state.positionIds
      }
    })
    return [
      {
        name: "personId",
        formItem: {
          type: "hidden"
        }
      },
      {
        title: "姓名",
        name: "fullName",
        tableItem: {},
        searchItem: {}
      },
      {
        title: "账号",
        name: "userName",
        tableItem: {},
        searchItem: {}
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {},
        dict: [
          {code: 1, codeName: "激活"},
          {code: 0, codeName: "禁用"}
        ]
      },
      {
        title: "品牌",
        name: "orgName",
        tableItem: {},
      },
      {
        title: "岗位",
        name: "positionNames",
        tableItem: {},
      },
      {
        title: "岗位",
        name: "positionIdList",
        searchItem: {
          diy: WizTableForm,
          ...positionConfig,
        }
      }
    ]
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const {getFieldDecorator} = this.props.form;

    let items = [
      <Item label="能力评估信息">
        {getFieldDecorator('abilityCheckItemId', {
          rules: [{required: true, message: '请选择能力评估信息'}],
          initialValue: this.initialValue.trainAbilityCheckItemId,
          initRows: []
        })(<WizTableForm onChange={this.clearOnChange.bind(this)} onClearWiz={this._onClearWiz.bind(this)}
                         selectType={'radio'} {...abilityCheckItem}
                         onSubmit={this.getTrainAbilityCheckItem.bind(this)}/>)}
      </Item>,
      <Item label="岗位"> {this.state.positionNames} </Item>
    ]
    if (this.state.abilityCheckItemId) {
      items.push(<Item label="选择学员" required layout="inline" style={{marginBottom: 0}}>
        {getFieldDecorator('personId', {
          rules: [{required: true, message: '请选择学员',}],
          initialValue: null
        })(<WizTableForm onClearWiz={this._onClearWiz2.bind(this)} rowkey='personId' rowName='fullName' tableApi={{
          path: 'personInfo/listByPage',
          apiParams: {
            excludePersonId: (this.props.hasPersonIdList ? this.props.hasPersonIdList : []),
            initPositionIdList: this.state.positionIds,
            organizationIdList: this.state.orgId
          }
        }}
                         columns={this.studentColumns()} title={'选择学员'} selectType={'radio'}
                         initRows={this.initialValue.personInfo} setData={this.setData.bind(this)}
                         onSubmit={this.getPersonInfo.bind(this)}/>)}
      </Item>)
      items.push(<Item label="账号" layout="inline" style={{marginBottom: 0, width: '100%'}}>
        <Item colon={false} style={{display: 'inline-block', width: '10%'}}>{this.state.userName}</Item>
        <Item label="学员岗位" style={{display: 'inline-block', marginLeft: '20%', width: '50%',}}
              wrapperCol={{
                xs: {span: 18, offset: 0},
                sm: {span: 18, offset: 0},
              }}
              labelCol={{
                xs: {span: 6, offset: 0},
                sm: {span: 6, offset: 0},
              }}>
          {this.state.userPositionNames}
        </Item>
      </Item>)
    }
    if (this.state.personId) {
      items.push(<Item label="评估时间" required layout="inline" style={{marginBottom: 0}}>
        {getFieldDecorator('checkTime', {
          rules: [{required: true, message: '请选择评估时间',}],
          initialValue: this.initialValue.startDate
        })(<WizDatePicker placeholder="请选择评估时间"/>)}
      </Item>)
      items.push(<Item label="能力项评分">
        {getFieldDecorator('list', {
          rules: [{required: true, message: '请填写能力项评分',}],
          initialValue: this.props.abilityItemsInfo ? this.props.abilityItemsInfo : [],
        })(<ScoreEditList/>)}
      </Item>)
    }

    return items
  }


  /**
   * 表单提交按钮
   */
  _submit() {
    if (this.state.personId) {
      return (
        <Item wrapperCol={{span: 12, offset: 6}}>
          <WizRow>
            <WizCol span={24} style={{textAlign: 'center'}}>
              <>
                <WizButton style={{marginLeft: 20}} title="保存" type="primary" htmlType="submit">保存</WizButton>
                <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>重置</WizButton>
              </>
            </WizCol>
          </WizRow>
        </Item>
      )
    }
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {
          values.orgId = this.state.orgId[0];
          values.positionIds = this.state.userPositionIds;
          this.props.onSubmit(values);
        }
      }
    });
  };


  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _onClearWiz2(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
      this.cleanStudent = callback
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {title} = this.props;
    const formItemLayout = {
      labelCol: {span: 6},
      wrapperCol: {span: 14},
    };

    return (
      <WizCard>
        <WizForm
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(StudentAbilityItemForm);


